<template>
  <div class="customer-detail">
    <div class="customer-header pt-0">
      <slot name="header"></slot>
      <div class="text-xs-right">
        <v-btn
          v-if="$store.state.userid == 'zwizadmin' || $store.state.userid.includes('zwiz')"
          v-clipboard:copy="user.id"
          v-clipboard:success="handleCopyUserId"
          v-clipboard:error="handleErrorCopyUserId"
          fab
          color="primary"
          depressed
          small
          class="extra-small"
          style="position: absolute; right: 0; top: 0"
        >
          <v-icon>file_copy</v-icon>
        </v-btn>
      </div>

      <div class="text-xs-center">
        <v-avatar size="100">
          <template v-if="user.profile_pic">
            <v-img
              :lazy-src="user.profile_pic"
              :src="user.profile_pic"
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <template #placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </template>
          <v-img
            v-else
            :src="'/static/img/assets/livechat/profile.png'"
            aspect-ratio="1"
            class="grey lighten-2"
          ></v-img>
        </v-avatar>
        <div class="text-xs-center mt-2 px-5" style="color: white">
          <edit-customer-value
            v-model="userRealname"
            :dark="true"
            :userid="user.id"
            :placeholder="$t('Name')"
            @onEdit="putuserrealname('realname', $event)"
          >
            <customer-item-value :value="userRealname">{{ userRealname }}</customer-item-value>
          </edit-customer-value>
          <div v-if="user.realname">({{ user.first_name }} {{ user.last_name }})</div>
        </div>
        <template
          v-if="
            isTremendous || selectedBot.theme === 'seagull' || selectedBot.unlock_open_bill == true
          "
        >
          <v-btn
            :href="`https://shopcommu.zwiz.app/ecommerce/${
              $route.name == 'allinonechat' ? $store.state.livechat.pageid : selectedBot.pageid
            }/?userid=${user.id}&sessiontoken=${
              user.sessiontoken
            }&lang=${currentLang}&category=all&app=${user.app}&from=livechat`"
            target="_blank"
            small
            depressed
            round
            outline
            dark
          >
            <v-icon class="mr-1" small>shopping_cart</v-icon>
            เปิดบิล
          </v-btn>
        </template>
        <template
          v-else-if="
            (['ecommercebasic', 'tcp'].includes(selectedBot.theme) ||
              (['ticket', 'summitcapital'].includes(selectedBot.theme) &&
                $store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid))) &&
            shoplink
          "
        >
          <div class="mb-4 text-xs-center">
            <v-btn :href="shoplink" target="_blank" small depressed round outline dark>
              <v-icon class="mr-1" small>shopping_cart</v-icon>
              {{ $t('Create order') }}
            </v-btn>
          </div>
        </template>
      </div>
    </div>
    <template v-if="!loading">
      <div v-if="selectedBot.theme == 'sahapan'" class="text-xs-right">
        <sahapan-add-manual :user="user"></sahapan-add-manual>
      </div>
      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Channel') }}</label>
          <p>
            <ChannelLabel :channel="user.app">
              <template #channel="{ channelColor, selectedChannel }">
                <span v-if="selectedChannel" :style="{ color: channelColor }">
                  <em v-if="selectedChannel.icon" :class="selectedChannel.icon" />
                </span>
              </template>
            </ChannelLabel>
          </p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('gender') }}</label>
          <!-- <p>{{ $t(user.gender) || $t(json_variable.gender) }}</p> -->
          <p>{{ $t(`${user.gender || '-'}`) }}</p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Locale') }}</label>
          <p>
            <template v-if="userLocale">
              <flag :iso="userLocale.icon" />
              {{ userLocale.title }}
            </template>
            <template v-else>-</template>
          </p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption">
            {{ $t('Status') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>
          <div>
            <p>
              <edit-customer-value
                v-model="user['status']"
                :userid="user.id"
                :placeholder="$t('Status')"
                :item-option="statusOptions"
                :multiple="false"
                :combobox="true"
                @onEdit="onEditStatus"
                @onSearch="onSearchStatus"
              >
                <customer-item-value :value="user['status']">{{ user.status }}</customer-item-value>
              </edit-customer-value>
            </p>
          </div>
        </v-flex>
        <v-flex
          v-if="pageid == '102549712095297' || pageid == '105387828535129'"
          xs12
          sm6
          class="pl-3 pr-3 pt-2 pb-2"
        >
          <label class="caption" for>{{ $t('Chat Status') }}</label>
          <Multiselect
            v-model="chatstatus"
            :options="chatstatusOption"
            :show-labels="false"
            :multiple="false"
            :searchable="false"
            :allow-empty="false"
            placeholder="Chat Status"
            @input="updateSession"
          ></Multiselect>
        </v-flex>

        <v-flex v-if="selectedBot.type == 'nextcapital'" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption">
            {{ $t('next_capital_register_date') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>
          <div>
            <p>
              {{ user.login_timestamp ? getFormatDate(user.login_timestamp, 'DD/MM/YYYY') : '-' }}
            </p>
          </div>
        </v-flex>

        <v-flex
          v-if="selectedBot.type == 'summithr' && user.member_status"
          xs12
          sm6
          class="pl-3 pr-3 pt-2 pb-2"
        >
          <label class="caption" for>สถานะพนักงาน</label>
          <div>
            <p>
              <edit-customer-value
                v-model="user['member_status']"
                :userid="user.id"
                placeholder="สถานะพนักงาน"
                :item-option="['active', 'inactive']"
                :multiple="false"
                :combobox="true"
                @onEdit="updateMemberStatus"
              >
                <customer-item-value :value="user['member_status']">{{
                  user.member_status
                }}</customer-item-value>
              </edit-customer-value>
            </p>
          </div>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <v-layout v-if="pageid == '100207768987988'" wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('first name') }}</label>
          <p>
            {{ userVar.first_name ? userVar.first_name : '-' }}
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('last name') }}</label>
          <p>{{ userVar.last_name ? userVar.last_name : '-' }}</p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Email') }}</label>
          <p>{{ userVar.email ? userVar.email : '-' }}</p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('phone no.') }}</label>
          <p>{{ userVar.phone ? userVar.phone : '-' }}</p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Province') }}</label>
          <p>{{ userVar.province ? userVar.province : '-' }}</p>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Register Date') }}</label>
          <p>
            {{ user.registertimestamp ? getFormatDate(user.registertimestamp, 'DD/MM/YYYY') : '-' }}
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Last Active Date') }}</label>
          <p>{{ user.timestamp ? getFormatDate(user.timestamp, 'DD/MM/YYYY') : '-' }}</p>
        </v-flex>

        <!-- Customize NT -->
        <template v-if="isNT">
          <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>Tier</label>
            <p class="primary--text">{{ user.tier || '-' }}</p>
          </v-flex>
          <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('service_number') }}</label>
            <template v-if="user.fixedline && user.fixedline.length > 0">
              <p
                class="primary--text"
                style="text-decoration: underline; cursor: pointer"
                @click="isShowNTService = true"
              >
                {{ $t('click_see_more') }} ({{ user.fixedline.length | numberFormat }})
              </p>
            </template>
            <template v-else>
              <p class="primary--text">-</p>
            </template>
          </v-flex>
          <v-dialog v-model="isShowNTService" scrollable max-width="800">
            <v-card>
              <v-card-title>
                {{ $t('service_number') }}
              </v-card-title>
              <v-divider />
              <v-card-text class="pa-0">
                <v-data-table
                  :headers="[
                    { text: $t('register_date'), value: 'createdate', sortable: false },
                    { text: $t('service_number'), value: 'baid', sortable: false }
                  ]"
                  :items="user.fixedline"
                  hide-actions
                  :no-data-text="$t('No Data')"
                >
                  <template #items="props">
                    <td>
                      {{ props.item.createdate | DateFormat('DD/MM/YYYY') }}
                    </td>
                    <td>
                      {{ props.item.baid }}
                    </td>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-spacer />
                <v-btn outline color="grey" @click="isShowNTService = false">{{
                  $t('close')
                }}</v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Email') }}</label>
          <p>
            <edit-customer-value
              v-model="user['email']"
              :userid="user.id"
              :placeholder="$t('Email')"
              @onEdit="onEditEmail"
            >
              <customer-item-value :value="user['email']">{{ user.email }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Context') }}</label>
          <p>
            <template v-if="ableToEditCustomer">
              <edit-customer-value
                v-model="user['context']"
                :userid="user.id"
                :placeholder="$t('Context')"
                @onEdit="onEditContext"
              >
                <customer-item-value :value="user['context']">{{
                  user.context
                }}</customer-item-value>
              </edit-customer-value>
            </template>
            <template v-else>
              {{ user.context || '-' }}
            </template>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('phone no.') }}</label>
          <p>
            <edit-customer-value
              v-model="user['phoneno']"
              type="number"
              :userid="user.id"
              :placeholder="$t('phone no.')"
              @onEdit="onEditPhone"
            >
              <customer-item-value :value="user['phoneno']">{{ user.phoneno }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Line ID') }}</label>
          <p>
            <edit-customer-value
              v-model="user['lineid']"
              :userid="user.id"
              :placeholder="$t('Line ID')"
              @onEdit="onEditLineId"
            >
              <customer-item-value :value="user['lineid']">{{ user.lineid }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('School') }}</label>
          <p>
            <edit-customer-school
              v-model="user['school']"
              :userid="user.id"
              :placeholder="$t('School')"
              @onEdit="onEditSchool"
            >
              <customer-item-value :value="user['school']">{{ user.school }}</customer-item-value>
            </edit-customer-school>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Province') }}</label>
          <p>
            <edit-customer-value
              v-model="user['province']"
              :userid="user.id"
              :placeholder="$t('Province')"
              @onEdit="onEditProvince"
            >
              <customer-item-value :value="user['province']">{{
                user.province
              }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
      </v-layout>
      <v-layout v-if="$store.state.rabbitPage.includes(selectedBot.pageid)" wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Card number') }}</label>
          <p>
            <edit-customer-value
              v-model="user['cardnumber']"
              :userid="user.id"
              :type="'number'"
              :placeholder="$t('Card number')"
              @onEdit="putusercardnumber('cardnumber', $event)"
            >
              <customer-item-value :value="user['cardnumber']">{{
                user.cardnumber
              }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Date of Birth') }}</label>
          <p>
            <edit-customer-value
              v-model="user['dob']"
              :userid="user.id"
              :placeholder="$t('Date of Birth')"
              type="date"
              @onEdit="saveSahapanUserProfile('dob', $event)"
            >
              <customer-item-value :value="user['dob']">
                <template v-if="user.dob">{{ user.dob | DateFormat('DD/MM/YYYY') }}</template>
                <template v-else>-</template>
              </customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex xs12 sm6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Address') }}</label>
          <p>
            <edit-customer-value
              v-model="user['address']"
              :userid="user.id"
              :placeholder="$t('Address')"
              @onEdit="saveSahapanUserProfile('address', $event)"
            >
              <customer-item-value :value="user['address']">{{ user.address }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
      </v-layout>
      <v-layout
        v-else-if="
          [...PAGE.JUZMATCH_CRM_TEST, ...PAGE.JUZMATCH_SALE_TEST].includes(selectedBot.pageid) &&
          parent == 'livechat'
        "
        row
        wrap
      >
        <v-flex xs12 sm6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Address') }}</label>
          <p>
            <edit-customer-value
              v-model="user['address']"
              :userid="user.id"
              :placeholder="$t('Address')"
              @onEdit="onEditAddress"
            >
              <customer-item-value :value="user['address']">{{ user.address }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
      </v-layout>
      <v-layout v-else row wrap>
        <v-flex xs12 sm6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Address') }}</label>
          <p>
            <edit-customer-value
              v-model="user['address']"
              :userid="user.id"
              :placeholder="$t('Address')"
              @onEdit="saveSahapanUserProfile('address', $event)"
            >
              <customer-item-value :value="user['address']">{{ user.address }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex v-if="isTremendous" xs12 sm6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>Link Google Map</label>
          <p>
            <edit-customer-value
              v-model="user['link']"
              :userid="user.id"
              placeholder="Link Google Map"
              @onEdit="onEditLink"
            >
              <customer-item-value :value="user['link']">{{ user.link }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex v-if="isTremendous" xs12 sm6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>Latitude</label>
          <p>
            <customer-item-value style="word-wrap: break-word" :value="user['address_lat']">{{
              user.address_lat
            }}</customer-item-value>
          </p>
        </v-flex>
        <v-flex v-if="isTremendous" xs12 sm6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>Longitude</label>
          <p>
            <customer-item-value style="word-wrap: break-word" :value="user['address_long']">{{
              user.address_long
            }}</customer-item-value>
          </p>
        </v-flex>

        <v-flex v-if="isTremendous" xs12 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>Google link by Latitude and Longitude</label>
          <p
            v-if="user.address_lat && user.address_long"
            class="text-primary"
            style="word-wrap: break-word"
          >
            <a
              target="_blank"
              :href="`https://maps.google.com/?q=${user.address_lat},${user.address_long}`"
              >{{ `https://maps.google.com/?q=${user.address_lat},${user.address_long}` }}</a
            >
          </p>
          <p v-else>-</p>
        </v-flex>
      </v-layout>

      <v-layout v-if="selectedBot.theme == 'sahapan'" wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Real First Name') }}</label>
          <p>
            <edit-customer-value
              v-model="user['realfirstname']"
              :userid="user.id"
              :placeholder="$t('Real First Name')"
              @onEdit="saveSahapanUserProfile('realfirstname', $event)"
            >
              <customer-item-value :value="user['realfirstname']">{{
                user.realfirstname
              }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Real Last Name') }}</label>
          <p>
            <edit-customer-value
              v-model="user['reallastname']"
              :userid="user.id"
              :placeholder="$t('Real Last Name')"
              @onEdit="saveSahapanUserProfile('reallastname', $event)"
            >
              <customer-item-value :value="user['reallastname']">{{
                user.reallastname
              }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Date of Birth') }}</label>
          <p>
            <edit-customer-value
              v-model="user['dob']"
              :userid="user.id"
              :placeholder="$t('Date of Birth')"
              type="date"
              @onEdit="saveSahapanUserProfile('dob', $event)"
            >
              <customer-item-value :value="user['dob']">
                <template v-if="user.dob">{{ user.dob | DateFormat('DD/MM/YYYY') }}</template>
                <template v-else>-</template>
              </customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex xs12 sm6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Address') }}</label>
          <p>
            <edit-customer-value
              v-model="user['address']"
              :userid="user.id"
              :placeholder="$t('Address')"
              @onEdit="saveSahapanUserProfile('address', $event)"
            >
              <customer-item-value :value="user['address']">{{ user.address }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <v-layout v-if="PAGE.JUZMATCH_CRM.includes(selectedBot.pageid)" wrap>
        <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
          <div>ข้อมูลการสมัครสมาชิก</div>
        </v-flex>
        <v-flex xs12 sm6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>Customer ID</label>
          <p>
            <edit-customer-value
              v-model="user['temp_msg']"
              :userid="user.id"
              :placeholder="$t('note')"
              @onEdit="onEditNote"
            >
              <customer-item-value style="white-space: pre-wrap" :value="user['temp_msg']">{{
                user.temp_msg
              }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex xs12 sm6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>ชื่อ</label>
          <p v-if="parent == 'livechat'">
            <edit-customer-value
              v-model="user['juzmatch_member_full_name']"
              :userid="user.id"
              :placeholder="$t('ชื่อ')"
              @onEdit="onEditJuzmatchMemberName"
            >
              <customer-item-value :value="user['juzmatch_member_full_name']">{{
                user.juzmatch_member_full_name || '-'
              }}</customer-item-value>
            </edit-customer-value>
          </p>
          <p v-else>{{ user.juzmatch_member_full_name }}</p>
        </v-flex>
        <v-flex xs12 sm6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>ประเภทบัญชี</label>
          <p>{{ user.juzmatch_member_type || '-' }}</p>
        </v-flex>
      </v-layout>

      <v-layout v-if="selectedBot.pageid == '100207768987988'" wrap>
        <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
          <div>ข้อมูลการสมัครสมาชิก</div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>ชื่อ-นามสกุล</label>
          <p>{{ json_var.first_name || '' }} {{ json_var.last_name || '' }}</p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('phone no.') }}</label>
          <p>
            {{ json_var.phone || '-' }}
          </p>
        </v-flex>
        <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Address') }}</label>
          <p>
            {{ json_var.address || '-' }}
          </p>
        </v-flex>
      </v-layout>

      <template v-if="isTremendous && user.memberid">
        <v-divider></v-divider>
        <v-layout wrap>
          <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('customer_type') }}</label>
            <edit-customer-value
              v-model="user['customer_type']"
              :userid="user.id"
              :placeholder="$t('customer_type')"
              :item-option="customerTypeOptions.map((option) => option.value)"
              :multiple="false"
              :combobox="true"
              :custom-label="
                (value) =>
                  (customerTypeOptions.find((option) => option.value === value) || {}).label || ''
              "
              @onEdit="handleCustomerTypeEdit"
            >
              <customer-item-value :value="user['customer_type']">{{
                user.customer_type
                  ? user.customer_type === 'old'
                    ? 'ลูกค้าเก่า'
                    : 'ลูกค้าใหม่'
                  : '-'
              }}</customer-item-value>
            </edit-customer-value>
          </v-flex>
          <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('pledge_water_tank') }}</label>
            <template v-if="ableToEditCustomer">
              <edit-customer-value
                v-model="user['total_pledge_water_tank']"
                :userid="user.id"
                :placeholder="$t('pledge_water_tank')"
                @onEdit="onEditPledgeWaterTank"
              >
                <customer-item-value :value="user['total_pledge_water_tank']">{{
                  user.total_pledge_water_tank
                }}</customer-item-value>
              </edit-customer-value>
            </template>
            <template v-else>
              {{ user.total_pledge_water_tank || '-' }}
            </template>
          </v-flex>

          <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('branch') }}</label>
            <edit-customer-value
              :value="
                (tremendousBranchOptions.find((option) => option.name === user.branch_name) || {})
                  .id
              "
              :userid="user.id"
              :placeholder="$t('branch_name')"
              :item-option="tremendousBranchOptions.map((option) => option.id)"
              :multiple="false"
              :combobox="true"
              :custom-label="
                (value) =>
                  (tremendousBranchOptions.find((option) => option.id === value) || {}).name || ''
              "
              @input="
                user.branch_name =
                  (tremendousBranchOptions.find((option) => option.id === $event) || {}).name || ''
              "
              @onEdit="handleTremendousBranchEdit"
            >
              <customer-item-value :value="user['branch_name']">{{
                user.branch_name
              }}</customer-item-value>
            </edit-customer-value>
          </v-flex>
        </v-layout>
      </template>

      <template v-if="selectedBot.type == 'root'">
        <v-divider></v-divider>
        <v-layout wrap>
          <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>{{ $t('Company Name') }}</label>
            <p>
              {{ user.company_name || '-' }}
            </p>
          </v-flex>
        </v-layout>
      </template>

      <template v-if="selectedBot.type == 'autocash'">
        <v-divider></v-divider>
        <v-layout wrap>
          <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
            <label class="caption" for>AD ID</label>
            <p>
              {{ user.member_ad_id || '-' }}
            </p>
          </v-flex>
        </v-layout>
      </template>

      <v-divider></v-divider>

      <div class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>
          {{ $t('Tag') }}
          <v-premium-lock :inline="true"></v-premium-lock>
        </label>

        <a
          v-if="$store.getters.getPackage == 'premium' && !isEditTag && !isCoachlab"
          href="javascript:void(0);"
          @click="editTag"
        >
          <em class="fa fa-pencil-alt middle" />
        </a>
      </div>

      <div class="pl-3 pr-3 pt-2 pb-2">
        <template v-if="!isEditTag">
          <div v-if="tags.length == 0" class="text-xs-left">{{ $t('No tag') }}</div>
          <ul class="tags">
            <li v-for="(tag, index) in tags" :key="'usertag_' + index" class="tag">
              <specialtext :text="tag"></specialtext>
            </li>
          </ul>
        </template>
        <template v-else>
          <tags
            v-model="usertag"
            :tags="usertags"
            style="margin-bottom: 5px"
            :btn-text="$t('Add tag')"
            :item-option="tagOptions"
            :combobox="true"
            @tags-changed="addUserTags"
            @before-adding-tag="checkUserTags"
            @onSearch="onSearchTag"
          ></tags>

          <div class="text-xs-center" style="margin-top: 15px">
            <v-btn outline color="grey" small @click="cancelEditTag">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" small @click="saveEditTag">{{ $t('Save') }}</v-btn>
          </div>
        </template>
      </div>

      <div v-if="$store.state.showSession.includes(selectedBot.pageid)">
        <v-divider></v-divider>
        <div v-if="userSession" class="pl-3 pr-3 pt-2 pb-2">
          <div class="mb-2">
            <label class="caption">
              {{ $t('Data Summary') }}
            </label>
          </div>

          <div
            v-if="typeof userSession === 'object'"
            style="
              overflow-y: auto;
              max-height: 300px;
              padding: 5px;
              background: #f7f7f7;
              border: 1px solid #eee;
              border-radius: 5px;
            "
          >
            <div
              v-for="(value, name, index) in userSession"
              :key="`key${index}`"
              style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
            >
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <span style="color: #ff706b">{{ name }}</span>
                </v-flex>
                <v-flex xs12 sm6 class="form-control">
                  {{ value }}
                </v-flex>
              </v-layout>
            </div>
          </div>
          <div v-else>
            <p>{{ userSession }}</p>
          </div>
        </div>
      </div>

      <div v-if="!PAGE.JUZMATCH_CRM.includes(selectedBot.pageid)" class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('Note') }}</label>
        <p>
          <edit-customer-value
            v-model="user['temp_msg']"
            :userid="user.id"
            :placeholder="$t('note')"
            :type="[...$store.state.bbqPage].includes(selectedBot.pageid) ? 'textarea' : 'text'"
            @onEdit="onEditNote"
          >
            <customer-item-value :value="user['temp_msg']">
              <template v-if="[...$store.state.bbqPage].includes(selectedBot.pageid)">
                <div style="word-break: break-word" v-html="sanitize(user.temp_msg)"></div>
              </template>
              <template v-else>
                <div style="word-break: break-word">{{ user.temp_msg }}</div>
              </template>
            </customer-item-value>
          </edit-customer-value>
        </p>
      </div>

      <v-divider></v-divider>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import CustomerItemValue from './customer/CustomerItemValue'
import EditCustomerValue from './EditCustomerValue'
import EditCustomerSchool from './EditCustomerSchool'
import specialtext from '@/components/elements/specialtext'
import Tags from '@/components/elements/Tags'
import SahapanAddManual from './customize/sahapan/SahapanAddManual'
import Multiselect from 'vue-multiselect'
import summitApi from '@/api/summit'
import { PAGE, PAGE_GROUP } from '@/constants/page.js'
import ChannelLabel from '@/components/elements/ChannelLabel'

import api from '@/api'
import tremendousApi from '../../../api/tremendous'
import usersApi from '../../../api/users'
import { handleApiError } from '../../../api/util'
import juzmatchApi from '@/api/juzmatch'
import DOMPurify from 'dompurify'

export default {
  components: {
    CustomerItemValue,
    EditCustomerValue,
    EditCustomerSchool,
    specialtext,
    SahapanAddManual,
    Tags,
    Multiselect,
    ChannelLabel
  },
  props: {
    value: {
      default: undefined
    },
    pageid: {
      default: undefined
    },
    parent: {
      default: 'all'
    }
  },
  data: function () {
    return {
      sahapandialog: true,
      loading: true,
      user: {},
      isEditTag: false,
      usertag: '',
      chatstatus: null,
      profile_pic: '',
      chatstatusOption: ['กำลังดำเนินการ', 'ดำเนินการแล้ว', 'ติดตาม'],
      tagOptions: [],
      statusOptions: [],
      userSession: null,
      showCopy: false,
      customerTypeOptions: [
        { label: 'ลูกค้าเก่า', value: 'old' },
        { label: 'ลูกค้าใหม่', value: 'new' }
      ],
      isShowNTService: false
    }
  },
  computed: {
    shoplink() {
      var url = ''
      if (window.location.href.includes('cms.zwiz.ai')) {
        url = 'https://shopv2.zwiz.app'
      } else if (
        window.location.href.includes('enterprise.zwiz.ai') ||
        window.location.href.includes('enterprise.zwiz.app') ||
        window.location.href.includes('staging.zwiz.ai') ||
        window.location.href.includes('localhost') ||
        this.selectedBot.theme == 'nvbb'
      ) {
        url = 'https://shopcommu.zwiz.app'
      } else {
        return false
      }

      var userid =
        this.$route.name == 'allinonechat'
          ? this.$store.state.livechat.pageid
          : this.selectedBot.pageid

      url =
        url +
        `/ecommerce/${userid}?userid=${this.user.id}&sessiontoken=${this.user.sessiontoken}&lang=${this.currentLang}&category=all&from=livechat&ref=${this.$store.state.userid}`
      return url
    },
    json_var() {
      if (this.user && this.user.json_variable) {
        let json_text = this.user.json_variable
        try {
          let json_obj = JSON.parse(json_text)
          return json_obj
        } catch (error) {
          console.error(error)
          return null
        }
      } else {
        return null
      }
    },
    botPageid() {
      return this.pageid ? this.pageid : this.selectedBot.pageid
    },
    sessionData() {
      let session = this.user.session ? JSON.parse(this.user.session) : {}
      if (session.chatstatus) {
        this.chatstatus = session.chatstatus
      }
      return session
    },
    userFullname() {
      if (this.user) {
        return (
          (this.user.first_name ? this.user.first_name : '') +
          (this.user.last_name ? ' ' + this.user.last_name : '')
        )
      } else return ''
    },
    memberDetail() {
      let userInfo = ''
      if (this.user && this.selectedBot.type == 'summithr' && this.user.member_status) {
        userInfo = `${this.user.member_status}`
      }
      return userInfo
    },
    userVar() {
      if (this.user) {
        return JSON.parse(this.user.json_variable)
      } else return {}
    },
    userRealname: {
      get() {
        if (this.user && this.user.realname) {
          return this.user.realname
        } else
          return (
            (this.user.first_name ? this.user.first_name : '') +
            (this.user.last_name ? ' ' + this.user.last_name : '')
          )
      },
      set(val) {
        this.user.realname
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      currentLang: 'currentLang'
    }),
    isBU() {
      return this.$store.state.pageBU.includes(this.botPageid)
    },
    filterIntent: function () {
      var vm = this
      if (!vm.user || !vm.user.intentlist || !vm.user.intentlist.length > 0) {
        return 0
      }
      try {
        return vm.user.intentlist.sort(function (a, b) {
          if (parseInt(a[1]) > parseInt(b[1])) {
            return -1
          }

          if (parseInt(a[1]) < parseInt(b[1])) {
            return 1
          }

          return 0
        })
      } catch (error) {
        console.error(error)
        return []
      }
    },
    userLocale: function () {
      var vm = this
      return config.locale.find(function (locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function () {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function (tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.user.tags = result.join(',')
      }
    },
    ableToEditCustomer() {
      return true
    },
    isTremendous() {
      return PAGE.TREMENDOUS.includes(this.selectedBot.pageid)
    },
    PAGE() {
      return PAGE
    },
    tremendousBranchOptions() {
      return (
        this.$store.state.tremendousMasterData.branch.map((el) => {
          return { name: el.branch_name, id: el.id }
        }) || []
      )
    },
    isNT() {
      return [PAGE_GROUP.NT].includes(this.selectedBot.page_group)
    }
  },
  watch: {
    // value: function() {
    //   this.user = this.value
    // }
  },
  async mounted() {
    if (!this.$store.state.tags) {
      const tags = await this.getUserTagList()
      this.$store.state.tags = tags || []
    }
    this.tagOptions = this.$store.state.tags || []

    if (!this.$store.state.status) {
      const status = await this.getUserStatusList()
      this.$store.state.status = status || []
    }
    this.statusOptions = this.$store.state.status || []
    this.getuserDetail()

    // this.user = this.value
    // this.cached_tag = this.user.tags
  },
  methods: {
    sanitize(dirty) {
      const raw = String(dirty ? dirty : '')
      const withBreaks = raw.replace(/\r\n|\r|\n/g, '<br>')
      const purify = DOMPurify
      purify.addHook('afterSanitizeAttributes', (node) => {
        if (node.tagName === 'A') {
          const href = node.getAttribute('href') || ''
          if (!/^(https?:|mailto:|tel:)/i.test(href)) {
            node.removeAttribute('href')
          }
          if (node.hasAttribute('target')) {
            node.setAttribute('rel', 'noopener noreferrer')
          }
        }
      })
      return purify.sanitize(withBreaks, {
        ALLOWED_TAGS: ['a', 'br'],
        ALLOWED_ATTR: ['href', 'target', 'rel'],
        ALLOWED_URI_REGEXP: /^(?:(?:https?):|mailto:|tel:)/i
      })
    },
    onEditAddress(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        address: payload.customer_value || ''
      }
      api.saveUserAddress(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    async onEditJuzmatchMemberName(payload) {
      const vm = this
      vm.$store.dispatch('loading')
      const body = {
        page_id: payload.pageid,
        user_id: payload.usersid,
        name: payload.customer_value || ''
      }
      try {
        await juzmatchApi.patchMember({ body })
        vm.$store.dispatch('loading')
        payload.onEdit()
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
      }
    },
    handleCopyUserId() {
      let vm = this
      vm.showCopy = true
    },
    handleErrorCopyUserId() {},
    async updateMemberStatus(payload) {
      try {
        const summit_user_id = this.user.roomid
        const status = payload.customer_value
        const page_id = payload.pageid
        const body = {
          status,
          summit_user_id,
          page_id
        }
        this.$store.dispatch('loading')
        await summitApi.updateMemberStatus(body)
        this.$store.dispatch('loading')
        payload.onEdit()
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          type: 'error',
          text: 'อัพเดทข้อมูลไม่สำเร็จ'
        })
      }
    },
    async updateSession() {
      let data = {
        pageid: this.pageid,
        userid: this.user.id,
        sessionobj: {
          chatstatus: this.chatstatus
        }
      }
      this.$store.dispatch('loading')
      await api.updateUserSession(data)
      this.$store.dispatch('loading')
    },
    setChatStaus(session) {
      try {
        let sessionObj = session ? JSON.parse(session) : {}
        if (sessionObj.chatstatus) {
          this.chatstatus = sessionObj.chatstatus
        }
      } catch (error) {}
    },
    setUserSession(session) {
      if (session) {
        try {
          this.userSession = JSON.parse(session)
        } catch (e) {
          this.userSession = session
        }
      }
    },
    putuserrealname(type, payload) {
      var vm = this
      this.$set(this.user, type, payload.customer_value)

      vm.$store.dispatch('loading')
      var data = {
        body: {
          usersid: this.user.id,
          realname: payload.customer_value
        },
        params: {
          pageid: this.botPageid
        }
      }
      api.putuserrealname(data, async function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        await vm.$store.dispatch('loadLatestUsers', {
          type: vm.$store.state.livechat.type
        })
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.$forceUpdate()
      })
    },
    putusercardnumber(type, payload) {
      var vm = this
      this.$set(this.user, type, payload.customer_value)

      vm.$store.dispatch('loading')
      var data = {
        body: {
          usersid: this.user.id,
          cardnumber: payload.customer_value
        },
        params: {
          pageid: this.selectedBot.pageid
        }
      }
      api.putusercardnumber(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.$forceUpdate()
      })
    },
    saveSahapanUserProfile(type, payload) {
      var vm = this
      this.$set(this.user, type, payload.customer_value)
      vm.$store.dispatch('loading')
      var data = {
        lineid: this.user.id,
        firstname: this.user.realfirstname,
        lastname: this.user.reallastname,
        gender: this.user.gender,
        address: this.user.address,
        dob: this.user.dob ? moment(this.user.dob).format() : moment().format(),
        phoneno: this.user.phoneno,
        email: this.user.email
      }
      api.saveSahapanUserProfile(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.$forceUpdate()
      })
    },
    getuserDetail() {
      const vm = this
      try {
        vm.loading = true
        const data = { pageid: vm.botPageid, userid: vm.value }
        api.getUserOnly(data, function (error, response) {
          if (error) console.error(error)

          vm.user = response && response.data[0]
          vm.setChatStaus(response && response.data[0].session)
          vm.setUserSession(vm.user.session)

          const realname =
            response && response.data[0].realname ? response.data[0].realname.split(' ') : ''
          vm.user.realfirstname = realname.length > 0 ? realname[0] : ''
          vm.user.reallastname = realname.length > 1 ? realname[1] : ''
          vm.user.dob = vm.user.dob
            ? moment(vm.user.dob).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD')
          vm.loading = false
        })
      } catch (error) {
        vm.loading = false
        console.error(error)
      }
    },
    onEditPledgeWaterTank(payload) {
      this.handleTremendousMemberUpdate(
        { total_pledge_water_tank: payload.customer_value },
        payload.onEdit
      )
    },
    onEditContext(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        context: payload.customer_value
      }

      api.saveUserContext(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditNote(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        temp_msg: payload.customer_value
      }
      // console.log(data)
      api.saveUserNote(data, function (error, response) {
        // console.log(response);
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    async onEditLink(payload) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const data = {
          page_id: payload.pageid,
          user_id: payload.usersid,
          link: payload.customer_value
        }
        await usersApi.postLink(data)
        payload.onEdit()
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('loading')
      }
    },
    saveEditTag: function () {
      var vm = this
      var data = {
        pageid: vm.botPageid,
        usersid: vm.user.id,
        tags: vm.user.tags
      }
      api.saveUserTags(data, function (error, response) {
        if (error) {
          console.error(error)
        }
        vm.cached_tag = vm.user.tags
        vm.isEditTag = false
      })
    },
    cancelEditTag: function () {
      this.user.tags = this.cached_tag
      this.isEditTag = false
    },
    editTag() {
      this.isEditTag = true
      this.cached_tag = JSON.parse(JSON.stringify(this.user.tags))
    },
    onFailLoad: function () {
      this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorTag = []
      // if (obj.tag.text.length > 25) {
      //   this.errorTag.push('overmaxlength')
      //   obj.error()
      // } else
      if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error('duplicate')
      } else obj.addTag()
    },
    onEditStatus: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        status: payload.customer_value
      }
      api.saveUserStatus(data, async function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        await vm.$store.dispatch('loadLatestUsers', {
          type: vm.$store.state.livechat.type
        })
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditLineId: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        lineid: payload.customer_value
      }
      api.saveUserLineId(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditSchool: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        school: payload.customer_value
      }
      api.saveUserSchool(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditProvince: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        province: payload.customer_value
      }
      api.saveUserProvince(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditEmail: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        email: payload.customer_value
      }
      api.saveUserEmail(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditPhone: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        phoneno: payload.customer_value
      }
      api.saveUserPhoneno(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    async getUserTagList(query) {
      var response = await api.getUserTagList({
        limit: 100,
        offset: 0,
        filter_name: query || undefined
      })
      if (response && response.result) {
        return response.result.map((item) => {
          return item.name
        })
      } else {
        return []
      }
    },
    async onSearchTag({ event, onComplete }) {
      const vm = this
      if (vm.updateSearchTagTimeout) {
        clearTimeout(vm.updateSearchTagTimeout)
      }
      vm.updateSearchTagTimeout = setTimeout(async () => {
        try {
          const tags = await vm.getUserTagList(event)
          onComplete(tags)
        } catch (error) {
          console.error(error)
        }
        vm.updateSearchTagTimeout = null
      }, 3000)
    },
    async getUserStatusList(query) {
      var response = await api.getUserStatusList({
        limit: 100,
        offset: 0,
        filter_name: query || undefined
      })
      if (response && response.result) {
        return response.result.map((item) => {
          return item.name
        })
      } else {
        return []
      }
    },
    async onSearchStatus({ event, onComplete }) {
      const vm = this
      if (vm.updateSearchStatusTimeout) {
        clearTimeout(vm.updateSearchStatusTimeout)
      }
      vm.updateSearchStatusTimeout = setTimeout(async () => {
        try {
          const status = await vm.getUserStatusList(event)
          onComplete(status)
        } catch (error) {
          console.error(error)
        }
        vm.updateSearchStatusTimeout = null
      }, 3000)
    },
    handleCustomerTypeEdit(payload) {
      if (!payload.customer_value) return
      this.handleTremendousMemberUpdate({ customer_type: payload.customer_value }, payload.onEdit)
    },
    handleTremendousBranchEdit(payload) {
      if (!payload.customer_value) return
      this.handleTremendousMemberUpdate({ branch_id: payload.customer_value }, payload.onEdit)
    },
    async handleTremendousMemberUpdate(payload, done) {
      try {
        const [field] = Object.keys(payload)

        const data = {
          pageId: this.selectedBot.pageid,
          memberId: this.user.memberid,
          data: {
            ...payload,
            action: 'edit',
            edit_field_list: {
              data: [
                {
                  field_name: field,
                  before:
                    this.user[field] ||
                    (field === 'branch_id'
                      ? (
                          this.tremendousBranchOptions.find(
                            (option) => option.name === this.user.branch_name
                          ) || {}
                        ).id || ''
                      : ''),
                  after: payload[field]
                }
              ]
            }
          }
        }
        this.$store.dispatch('loading')
        const response = await tremendousApi.patchUpdateMember(data)
        this.$store.dispatch('loading')
        if (response && response.status === 200) {
          this.user[field] = payload[field]
          await this.$swal.fire({
            text: 'บันทึกสำเร็จ',
            type: 'success'
          })
          done()
        }
      } catch (error) {
        this.$store.dispatch('loading')
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/TicketCustomerDetail.vue